import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { retrieveAccessToken, validateToken } from '@utils';
import { LocaleLink, AuthLink } from '@common/components';
import { ExpandableList } from './ExpandableList';
import { useAnalytics } from '@utils/analytics';
import styles from './SmallList.module.scss';
import { getLanguagePrefix } from '@helpers';
import { LanguageSwitch } from './LanguageSwitch';

export const SmallList = ({ items, onClick }) => {
  const token = retrieveAccessToken();
  const isAuth = validateToken(token);
  const { trackInteraction } = useAnalytics();
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);

  return (
    <ul className={styles.list}>
      {items.map((item, i) => {
        const linkType = item.link.options.attributes?.type || null;

        return (
          <Fragment key={item.drupal_id}>
            {items.length !== 1 && i === 0 && (
              <li className={`${styles.item} ${styles.langSelect}`}>
                <LanguageSwitch />
              </li>
            )}
            {item.children && item.children.length > 0 ? (
              <li className={styles.item}>
                <ExpandableList
                  title={item.title}
                  items={item.children}
                  expanded={item.expanded}
                />
              </li>
            ) : linkType === 'auth' ? (
              <AuthLink
                menu="SIDE_NAVIGATION"
                item={item}
                styles={styles}
                isAuth={isAuth}
                onClick={onClick}
              />
            ) : (
              <li className={styles.item}>
                <LocaleLink
                  to={
                    window.location.origin +
                    getLanguagePrefix(language) +
                    item.link.uri.replace('internal:', '')
                  }
                  className={styles.link}
                  onClick={() =>
                    trackInteraction(
                      'side-navigation',
                      item.title,
                      item.link.uri.replace('internal:', ''),
                      'side-navigation'
                    )
                  }
                >
                  {item.title}
                </LocaleLink>
              </li>
            )}
          </Fragment>
        );
      })}
    </ul>
  );
};

SmallList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.any),
  onClick: PropTypes.func,
};

SmallList.defaultProps = {
  onClick: () => {},
};
